import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b00cf792"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "font text-body-2 text-secondary font-weight-bold"
}
const _hoisted_2 = {
  key: 0,
  class: "font text-body-2 text-secondary font-weight-bold"
}
const _hoisted_3 = { key: 0 }

import { RoutesNames } from '@/router/routesNames';
import { useRouter } from 'vue-router';
import { Company } from '@/graphql/types/graphql';
import { withDefaults } from 'vue';
import { useUserStore } from '@/store/user';
import { useDialogsStore } from '@/store/dialogs';
import { useI18n } from 'vue-i18n';
import { useChangeCurrentAppVisualizzation } from '@/composables/user';
import { CurrentAppVisualizationType } from '@/graphql/types/graphql';
import { isSmallDevice } from '@/utils/helpers';
import { EnvVars, getEnv } from '@/utils/env';

interface CompanyMenuProps {
    company: Company;
    theme: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyProfileMenu',
  props: {
    company: { default: null },
    theme: { default: 'white' }
  },
  setup(__props: any) {

const { t } = useI18n();
const userStore = useUserStore();
const dialogsStore = useDialogsStore();

const {
    mutate: changeCurrentAppVisualizzation,
    loading: loadingUpdate,
    onDone: onDonechangeCurrentAppVisualizzation,
} = useChangeCurrentAppVisualizzation();

const router = useRouter();

const props = __props;

function goToEditCompanyProfile() {
    router.push({
        name: RoutesNames.edit_company_profile,
    });
}

function getCompanyName() {
    return props.company && props.company.companyName ? props.company.companyName : '';
}

function getCompanyId() {
    return props.company ? props.company.companyId : null;
}

function changeCurrentCompany() {
    dialogsStore.changeCompany = true;
}

function addCompany() {
    dialogsStore.addCompany = true;
}

function isWhite() {
    return props.theme === 'white';
}

function actionViewType() {
    return userStore.viewTypeUser ? t('view_type_company') : t('view_type_user');
}

async function changeViewType() {
    let companyId = getCompanyId();

    if (!companyId) {
        const allCompanies = userStore.allCompanies;
        if (allCompanies && allCompanies.length > 0) {
            companyId = allCompanies[0].companyId;
        }
    }

    const payload: any = {
        type: userStore.viewTypeUser
            ? CurrentAppVisualizationType.Company
            : CurrentAppVisualizationType.User,
    };

    if (payload.type === CurrentAppVisualizationType.Company) {
        payload.companyId = companyId;
    }

    await changeCurrentAppVisualizzation(payload);
}

onDonechangeCurrentAppVisualizzation(() => {
    router.replace({ name: RoutesNames.company_dashboard_courses_list });
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { class: "menu-custom" }, {
    activator: _withCtx(({ props }) => [
      (isWhite())
        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
            elevation: "0",
            variant: "outlined",
            color: "lightGray",
            rounded: "pill"
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "secondary",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-menu")
                ]),
                _: 1
              }),
              (!_unref(isSmallDevice)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(getCompanyName()), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040))
        : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 1 }, props, {
            elevation: "0",
            color: "white",
            rounded: "pill",
            class: "ml-4"
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "secondary",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-menu")
                ]),
                _: 1
              }),
              (!_unref(isSmallDevice)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(getCompanyName()), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        class: "font",
        style: {"margin-left":"-110px"}
      }, {
        default: _withCtx(() => [
          (getCompanyId())
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(userStore).isAdminInCurrentCompany)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      class: "cursor",
                      onClick: goToEditCompanyProfile
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "text-body-2 text-secondary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('company_profile')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(userStore).allCompanies.length > 1)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                class: "cursor",
                onClick: changeCurrentCompany
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "text-body-2 text-secondary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('change_company')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})